import styled from "styled-components/macro";

export const StyledTwoBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 1rem 0 2.2rem 0; 
`;

export const StyledTitle = styled.h1`
    font-size: 18px;
    margin-bottom: 1.6rem;
    font-weight: 600;
`;

export const StyledTitleBold = styled.h1`
    font-size: 32px;
    line-height:48px;
    margin-bottom: 1.6rem;
    font-weight: 600;
`;

export const StyledPurchaseDetails = styled.div`
    background: #ffffff;
    margin: auto;
    width: 330px;
    padding: 2rem 45px;
    border-radius: 4px;
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    h4 {
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 18px;
    }
`

export const StyledLinkButton = styled.button`
    border: none;
    background: transparent;
    color: #6270C6;
    cursor: pointer;
    &:focus {outline:0;}
`

export const ErrorContainer = styled.div`
    padding: 0.6rem 0;
    background: #f87171;
    width: 100%;
    color: #ffffff;
    text-align: center;
    margin-top: 1rem;
`;

export const SuccessContainer = styled.div`
    padding: 0.6rem 0;
    background: #4BB543;
    width: 100%;
    color: #ffffff;
    text-align: center;
    margin-top: 1rem;
`